export default __webpack_public_path__ + "static/media/connect-dark.f2d6879f.png";